import Loadable from "react-loadable";

export default pattern =>
  Loadable({
    loader: () => import(`../components/patterns/${pattern}`),
    loading() {
      return null;
    }
  });



// WEBPACK FOOTER //
// ./src/loadables/Pattern.js